import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';

interface IERdvNavigationWidgetProps {
    dictPreviousLabel: string;
    dictNextLabel: string;
    maxIndex: number;
    handleNavTo: (val: number) => void;
    formStep: number;
    hideFirstStep: boolean;
    showValidateButton: boolean;
    resetEnabled: boolean;

    setCaptcha: (token: string) => void;
    restoreLinks: () => void;
}

export class ERdvNavigationWidget extends Component<IERdvNavigationWidgetProps> {
    constructor(props: IERdvNavigationWidgetProps) {
        super(props);
        this.state = {};
    }

    handleNext = (event: React.SyntheticEvent<HTMLElement>) => {
        event.preventDefault();
        if (this.props.formStep < this.props.maxIndex) {
            if (this.props.resetEnabled) {
                this.props.restoreLinks();
            }

            if (this.props.formStep === 3) {
                const captchaInput =
                    event.currentTarget.querySelector<HTMLInputElement>(
                        'input[type="hidden"][name="captchaToken"]'
                    );
                const captchaToken = captchaInput ? captchaInput.value : '';
                this.props.setCaptcha(captchaToken);
            }

            this.props.handleNavTo(this.props.formStep + 1);
        }
    };

    handlePrevious = () => {
        if (this.props.formStep > 0) {
            this.props.handleNavTo(this.props.formStep - 1);
        }
    };

    render() {
        const cursorPointer = {
            cursor: 'pointer',
            fontSize: '75%',
        } as React.CSSProperties;

        return (
            <div className="row mt-5">
                <div className="offset-lg-4 col-lg-4 offset-md-1 col-md-10">
                    <div className="d-flex justify-content-between">
                        <div>
                            {((this.props.hideFirstStep &&
                                this.props.formStep > 1) ||
                                (!this.props.hideFirstStep &&
                                    this.props.formStep > 0)) && (
                                <a
                                    className="down-link"
                                    onClick={this.handlePrevious}
                                    style={cursorPointer}
                                >
                                    <i className="icon-angleLeft"></i>{' '}
                                    {this.props.dictPreviousLabel}
                                </a>
                            )}
                        </div>
                        <div>
                            {this.props.formStep < this.props.maxIndex &&
                                this.props.showValidateButton && (
                                    <>
                                        {this.props.formStep === 3 && (
                                            <form onSubmit={this.handleNext}>
                                                <button
                                                    type="submit"
                                                    className="btn-primary down-link"
                                                    style={cursorPointer}
                                                >
                                                    {this.props.dictNextLabel}
                                                </button>
                                            </form>
                                        )}
                                        {this.props.formStep !== 3 && (
                                            <a
                                                className="btn-primary down-link"
                                                style={cursorPointer}
                                                onClick={this.handleNext}
                                            >
                                                {this.props.dictNextLabel}
                                            </a>
                                        )}
                                    </>
                                )}
                        </div>
                    </div>
                </div>
                <div></div>
                <div className="col-md-5 col-sm-12 text-sm-right text-md-center text-right"></div>
            </div>
        );
    }
}

WidgetHelper.register(ERdvNavigationWidget, 'erdv-navigation-widget');
